import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Grid,
  Typography,
  Card,
  CardContent,
  Tooltip,
  withStyles,
  Button,
} from "@material-ui/core";
import styled from "styled-components/macro";
import { useDispatch, useSelector } from "react-redux";
import { AppStateType } from "../../../../redux/reducers";
import {
  createA11y,
  deleteA11y,
  deleteCreateA11y,
  fetchA11yes,
  updateA11y,
} from "../../../../redux/actions/a11yesActions";
import { GradientText, GradientWrapper } from "./SwitchControl";
import { FeedBackInfoMap, ModalController } from ".";
import { UnitStandardContext } from "../QuestionTabs";
import { Close as CloseIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import {checkDependsCondition} from "../../../../utils/functions";

type RadioType = {
  attribute: any;
  itemKey: any;
  unitId: any;
};

const UnselectedButton = withStyles({
  root: {
    borderRadius: "50%",
    width: 30,
    minWidth: 30,
    height: 30,
    //color: "#727783",
    color: "#929AA9",
  },
})(Button);

const QTitle = styled(Box)`
    ${(props) => props.theme.breakpoints.down("sm")} {
      font-size: 14px;
    }
`

export default function RadioControl({
  attribute,
  itemKey,
  unitId,
}: RadioType) {
  const dispatch = useDispatch();
  const user: any = useSelector(
    (state: AppStateType) => state.authReducer.user
  );
  const a11yes: any = useSelector(
    (state: AppStateType) => state.a11yesReducer.a11yes
  );
  const [a11y, setA11y] = useState<any>({});
  const [value, setValue] = useState("");
  const unitStandard = useContext(UnitStandardContext);
  const { t } = useTranslation();

  useEffect(() => {
    (async function () {
      if (value) {
        onFetchA11y();
      }
    })();
  }, [value]);

  const onFetchA11y = async () => {
    await dispatch(fetchA11yes(unitId, user.token));
  };

  const onCreateA11y = async (a11yData: any) => {
    await dispatch(createA11y(a11yData, user.token));
  };

  const onUpdateA11y = async (a11yData: any) => {
    const a11yIndex = a11yes.findIndex(
      (item: any) => item.attribute === a11y.attribute
    );
    dispatch(updateA11y(a11yIndex, a11y.id, a11yData, user.token));
  };

  const onDelete = async () => {
    const a11yIndex = a11yes.findIndex(
      (item: any) => item.attribute === a11y.attribute
    );
    await dispatch(deleteA11y(a11y.id, user.token, a11yIndex));
    setA11y({});
    await onFetchA11y();
  };

  const onChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const a11yData = {
      item: itemKey,
      attribute: `${attribute.key}__${e.target.value}`,
      accessibility_unit: unitId,
    };
    if (!a11y.id) {
      await onCreateA11y(a11yData);
    } else if (a11y.id) {
      await onUpdateA11y(a11yData);
    }
  };

  useEffect(() => {
    attribute.values.forEach((item: any) => {
      const isPresent = a11yes.find((a11y: any) => (
        a11y.attribute === `${attribute.key}__${item.key}` &&
        a11y.item === itemKey
      ));
      if (isPresent) {
        setValue(item.key);
        setA11y(isPresent);
      }
    });
    return () => {
      setA11y({});
      setValue("");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [a11yes]);

  const currentFeedback = FeedBackInfoMap.find((el) => {
    if (!el.attribute) {
      return el.key === attribute.key && el.unit_key === unitStandard.key;
    }
    return (
      el.key === attribute.key &&
      el.unit_key === unitStandard.key &&
      el.attribute &&
      a11y &&
      a11y.attribute === el.attribute
    );
  });
  const feedbackMap = {
    q_title: attribute.q_title,
    img: currentFeedback ? currentFeedback.img : "",
  };
  return (
    <>
      {checkDependsCondition(a11yes, attribute.depends_on) ? (
        <Box mt={3}>
          <Card>
            <CardContent>
              <FormControl fullWidth>
                <Typography variant="h6">
                  {attribute.is_mandatory === true ? (
                    <GradientWrapper>
                      <GradientText>{t("CLP_UnitMandatoryLabel")}</GradientText>
                    </GradientWrapper>
                  ) : null}
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <QTitle>{attribute.q_title}</QTitle>
                      {/* {attribute.key} |||
                                            {a11y && a11y.attribute} */}
                      {/* {console.log(a11y)} */}
                      <ModalController
                        showButton={!!currentFeedback}
                        feedbackMap={feedbackMap}
                      />
                    </div>
                    {a11y.id ? (
                      <>
                        <Tooltip title="Delete your answer">
                          <UnselectedButton color="primary" onClick={onDelete}>
                            <CloseIcon fontSize="inherit" />
                          </UnselectedButton>
                        </Tooltip>
                      </>
                    ) : null}
                  </Box>
                </Typography>

                <Box mt={3}>
                  <RadioGroup
                    row
                    // name={name}
                    value={value}
                    onChange={onChange}
                  >
                    <Grid container>
                      {attribute.values.map((item: any, index: any) => (
                        <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
                          <FormControlLabel
                            value={item.key}
                            control={<Radio key={index} />}
                            label={item.title}
                            key={index}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </RadioGroup>
                </Box>
              </FormControl>
            </CardContent>
          </Card>
        </Box>
      ) : null}
    </>
  );
}
